export default "__VITE_ASSET__CpWHwGFG__"